module.exports = __webpack_public_path__ + "img/icon_main.a866e1eb.png";